import React from 'react';
import { Create, useNotify, useRedirect } from 'react-admin';
import OrderForm, { transformOrder } from './OrderForm';
import useAuthorize from '../hooks/useAuthorize';
import { UserRole } from '../types/types';

export const OrderCreate = (props: any) => {
    const notify = useNotify();
    const redirect = useRedirect();
    useAuthorize([UserRole.Admin, UserRole.ProductAdmin]);

    const onSuccess = () => {
        notify('Order created successfully', { type: 'info' });
        redirect('/orders');
    };

    return (
        <Create {...props} mutationOptions={{ onSuccess }} transform={transformOrder}>
            <OrderForm />
        </Create>
    );
};
